<template>
  <div class="webpagelink" @click="openWebPage">
        <span class="webpagename">{{title}}</span>
    </div>
</template>

<script>

export default {
  uuid: '00000000-0000-0000-0000-000000100018',
  components: {},
  props: [
    'datamodel',
  ],
  data() {
    return {
      
    }
  },
  computed: {
    title() {
      return this.datamodel.value.webpagename
    },
    content() {
        return this.datamodel.value.webpagelink
    }
  },
  methods: {
    viewFile() {
        let link = this.datamodel.value.webpagelink
        if(!link.startsWith("http")) {
            link = "//" + link
        }
        window.open(link)
    },
    openWebPage() {
      let link = this.datamodel.value.webpagelink
      if (link.startsWith('http://') || link.startsWith('https://')) {
          window.open(link);
      }else{
        window.open("//" + link);
      }
    }
  },
  created() {},
  mounted() {

  }
}
</script>
<style lang="scss" scoped>
.weblink {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
        color: #0BBCAC;
        margin-left: 8px;
    }
    // margin: 0 31px;
}

.webpagelink {
  margin: 16px 0;
  border: 1px solid #0BBCAC;
  border-radius: 2px;
  min-height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    margin: 8px;
    text-align: start;
  }

  color: #0BBCAC;
  background: #F3FAFF;
  font-family: PingFang SC;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0em;
  text-align: center;

}

</style>
